<div id="banner-slider" dir="ltr" class="banner-slider-wrapper">
  <div class="card">
    <div 
      #swiperContainer
      class="swiper-container banner-slider">
    
    <div class="swiper-wrapper">
      <div *ngFor="let slide of slides; let i = index" class="swiper-slide">
        <div class="item-card banner slide-card" [ngStyle]="bannerCardStyle || {}" (click)="onSlideClick(slide, i)">
          <!-- Video content -->
          <video 
            *ngIf="slide?.videoUrl && slide.videoUrl.trim()" 
            [id]="'slide-video-' + i"
            [src]="slide.videoUrl"
            class="slide-video type-image"
            [muted]="isMuted"
            playsinline
            preload="metadata"
            (ended)="onVideoEnded(i)"
            (error)="onVideoError(i)"
            (loadstart)="onVideoLoadStart(i)">
            Your browser does not support the video tag.
          </video>
          
          <!-- Image content -->
          <img 
            *ngIf="slide?.imageUrl && slide.imageUrl.trim() && !(slide?.videoUrl && slide.videoUrl.trim())" 
            [src]="slide.imageUrl" 
            alt=""
            class="slide-image type-image">
        </div>
      </div>
    </div>

    </div>
  </div>
  
  <!-- Pagination below swiper -->
  <div class="swiper-pagination banner-pagination"></div>

  <!-- Mute button overlay -->
  <div *ngIf="isVideoPlaying" class="mute-button-container">
    <button 
      type="button"
      class="mute-button"
      (click)="toggleMute()"
      [attr.aria-label]="isMuted ? 'Unmute videos' : 'Mute videos'">
      <svg 
        *ngIf="isMuted" 
        class="mute-icon"
        viewBox="0 0 24 24" 
        fill="currentColor">
        <path d="M3.63 3.63a.996.996 0 000 1.41L7.29 8.7 7 9H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71v-4.17l4.18 4.18c-.49.37-1.02.68-1.6.91-.36.15-.58.53-.58.92 0 .72.73 1.18 1.39.91.8-.33 1.54-.77 2.2-1.31l1.34 1.34a.996.996 0 101.41-1.41L5.05 3.63c-.39-.39-1.02-.39-1.42 0zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-3.83-2.4-7.11-5.78-8.4-.59-.23-1.22.23-1.22.86v.19c0 .38.25.71.61.85C17.18 6.54 19 9.06 19 12zm-8.71-6.29l-.17.17L12 7.76V6.41c0-.89-1.08-1.33-1.71-.7zM16.5 12A4.5 4.5 0 0014 7.97v1.79l2.48 2.48c.01-.08.02-.16.02-.24z"/>
      </svg>
      <svg 
        *ngIf="!isMuted" 
        class="mute-icon"
        viewBox="0 0 24 24" 
        fill="currentColor">
        <path d="M3 9v6h4l5 5V4L7 9H3zm7-.17v6.34L7.83 13H5v-2h2.83L10 8.83zM16.5 12A4.5 4.5 0 0014 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77 0-4.28-2.99-7.86-7-8.77z"/>
      </svg>
    </button>
  </div>
</div>
